// src/components/Footer.js

import React from "react";
import { Link } from "react-router-dom";
import JoinWaitlistButton from "./JoinWaitlistButton";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";
import "./Footer.css";

function Footer() {
  return (
    <footer className="pt-32 pb-16 px-6">
      <div className="container mx-auto">
        <div className="relative overflow-hidden bg-black rounded-[3rem] p-12 md:p-20 shadow-2xl">
          {/* Decorative Elements */}
          <div className="absolute top-0 right-0 w-96 h-96 bg-blue-600/10 blur-[100px] rounded-full -mr-48 -mt-48" />
          
          <div className="relative z-10 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-16">
            {/* Left Section */}
            <div className="max-w-2xl">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600/10 text-blue-400 rounded-full text-sm font-bold mb-8 border border-blue-600/20">
                <span>✨</span> Early Access
              </div>
              <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight leading-tight">
                Join the early access now.
              </h2>
              <p className="text-gray-400 text-lg md:text-xl font-medium mb-10 leading-relaxed">
                Braccet will be launching very shortly. Be among the first to experience the future of viral collaboration.
              </p>
              <JoinWaitlistButton />
            </div>

            {/* Right Section / Links */}
            <div className="flex flex-col gap-8 text-white min-w-[200px]">
              <p className="text-gray-500 font-bold uppercase tracking-widest text-sm">Follow Us</p>
              <div className="flex gap-6">
                <a href="#" className="w-14 h-14 bg-white/5 rounded-2xl flex items-center justify-center border border-white/10 transition-all hover:bg-white/20 hover:scale-110 active:scale-95">
                  <FaFacebook className="text-2xl text-blue-500" />
                </a>
                <a href="#" className="w-14 h-14 bg-white/5 rounded-2xl flex items-center justify-center border border-white/10 transition-all hover:bg-white/20 hover:scale-110 active:scale-95">
                  <FaTwitter className="text-2xl text-blue-400" />
                </a>
                <a href="#" className="w-14 h-14 bg-white/5 rounded-2xl flex items-center justify-center border border-white/10 transition-all hover:bg-white/20 hover:scale-110 active:scale-95">
                  <FaInstagram className="text-2xl text-pink-500" />
                </a>
              </div>
            </div>
          </div>

          <div className="mt-24 pt-12 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-8">
            <div className="text-white text-4xl md:text-6xl font-black tracking-tighter opacity-20">
              BRACCET
            </div>
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-8">
              <Link to="/privacy-policy" className="text-gray-500 hover:text-white transition-colors font-medium text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms-of-use" className="text-gray-500 hover:text-white transition-colors font-medium text-sm">
                Terms of Use
              </Link>
              <Link to="/csae-policy" className="text-gray-500 hover:text-white transition-colors font-medium text-sm">
                CSAE Policy
              </Link>
              <p className="text-gray-500 font-bold">
                © {new Date().getFullYear()} Braccet Inc. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
